<template>
  <transition name="fade">
    <v-card class="product-exist-card elevation-3">
      <v-card-text class="pt-4 px-6 pb-6">
        <v-overlay :value="loader" absolute color="#fff" opacity="0.8">
          <div class="text-center">
            <v-progress-circular indeterminate color="primary" size="48" class="mb-2"></v-progress-circular>
            <div class="primary--text font-weight-medium">Cargando producto...</div>
          </div>
        </v-overlay>

        <div>
          <v-form @submit.prevent="checkForm">
            <!-- Selector de producto principal -->
            <v-row class="mb-4">
              <v-col cols="12">
                <v-autocomplete
                  v-model="producto"
                  :items="comp_prod"
                  item-value="id"
                  item-text="text"
                  label="Seleccionar Producto Existente"
                  placeholder="Busca un producto por su nombre o código"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="lni lni-search"
                  :error-messages="errors.producto || []"
                  :error="!!errors.producto"
                  class="rounded-lg"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Sección dinámica si hay producto seleccionado -->
            <v-row v-if="producto != ''">
              
              <!-- BANNER DE DETALLE DE PRODUCTO -->
              <v-col cols="12" class="mb-2">
                <div class="info-banner pa-4 d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center">
                  <div>
                    <h3 class="subtitle-1 font-weight-bold primary--text mb-1">
                      {{ nombre }}
                    </h3>
                    <div class="caption text-muted">
                      <span class="mr-3"><strong>Código:</strong> {{ codigo || 'N/A' }}</span>
                      <span><strong>Moneda Base:</strong> {{ actualMoneda }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap mt-3 mt-sm-0" style="gap: 12px;">
                    <v-chip color="blue lighten-5" text-color="blue darken-3" class="font-weight-medium rounded-pill elevation-0 px-3">
                      <i class="lni lni-package mr-1"></i> Existencia: {{ comp_suggest_price.Stock }} {{ Unidad }}
                    </v-chip>
                    <v-chip color="green lighten-5" text-color="green darken-3" class="font-weight-medium rounded-pill elevation-0 px-3">
                      <i class="lni lni-dollar mr-1"></i> P.V. Actual: ${{ comp_suggest_price.PV }} MXN
                    </v-chip>
                  </div>
                </div>
              </v-col>

              <!-- PANEL IZQUIERDO: FACTURACIÓN -->
              <v-col md="6" cols="12">
                <v-card outlined class="rounded-lg pa-4 h-100 fill-height" style="border: 1px solid rgba(0,0,0,0.12);">
                  <div class="section-title mb-3">
                    <i class="lni lni-files primary--text mr-2"></i>
                    <span>Detalle de Facturación</span>
                  </div>

                  <!-- Chips de facturas en el documento -->
                  <div class="mb-4" v-if="facturasDocument && facturasDocument.length > 0">
                    <div class="caption text-muted mb-2 font-weight-medium">
                      Facturas registradas en este documento (Selecciona una):
                    </div>
                    <div class="d-flex flex-wrap" style="gap: 8px;">
                      <v-chip
                        v-for="(fact, index) in facturasDocument"
                        :key="index"
                        @click="selectExistFactura(fact)"
                        :color="factura === fact.Id ? 'primary' : 'grey lighten-3'"
                        :text-color="factura === fact.Id ? 'white' : 'grey darken-3'"
                        class="bill-chip rounded-pill"
                        small
                      >
                        <i :class="[factura === fact.Id ? 'lni lni-checkmark-circle mr-1' : 'lni lni-file mr-1']"></i>
                        {{ fact.Nombre }} - {{ fact.ProvNombre }}
                      </v-chip>
                    </div>
                  </div>

                  <!-- Buscadores de Proveedor y Factura -->
                  <v-row class="mt-2">
                    <v-col md="6" cols="12">
                      <div class="model-select-wrapper">
                        <label>Proveedor</label>
                        <model-select
                          :options="comp_proveedor"
                          v-model="provedorSearch"
                          @searchchange="searchProv"
                          placeholder="Buscar proveedor..."
                        ></model-select>
                      </div>
                    </v-col>
                    <v-col md="6" cols="12">
                      <div class="model-select-wrapper" :class="{ 'has-error': errors.factura }">
                        <label>Factura</label>
                        <model-select
                          :options="comp_fact"
                          v-model="factura"
                          @select="onSelectProv"
                          placeholder="Seleccionar factura..."
                        ></model-select>
                        <div v-if="errors.factura" class="error-msg-text red--text caption mt-1 ml-1">
                          <i class="lni lni-warning mr-1"></i> {{ errors.factura }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Botón de asistencia factura -->
                  <div class="helper-banner pa-3 mt-4 d-flex align-center justify-space-between flex-wrap" style="gap: 8px;">
                    <span class="caption text-muted font-weight-medium">
                      <i class="lni lni-question-circle mr-1"></i> ¿No encuentras tu factura?
                    </span>
                    <v-btn
                      @click="keyformFactura++; showModalFactura = true;"
                      color="primary"
                      x-small
                      depressed
                      class="rounded-pill px-3 font-weight-bold"
                    >
                      <i class="lni lni-plus mr-1"></i> Agregar Nueva
                    </v-btn>
                  </div>
                </v-card>
              </v-col>

              <!-- PANEL DERECHO: DETALLES DE INGRESO -->
              <v-col md="6" cols="12">
                <v-card outlined class="rounded-lg pa-4 h-100 fill-height" style="border: 1px solid rgba(0,0,0,0.12);">
                  <div class="section-title mb-4">
                    <i class="lni lni-cart-full primary--text mr-2"></i>
                    <span>Detalles de Ingreso</span>
                  </div>

                  <v-row>
                    <!-- Compra: Precio y Moneda -->
                    <v-col md="6" cols="12" class="py-1">
                      <v-text-field
                        v-model="precioCompra"
                        type="number"
                        label="Precio de Compra"
                        placeholder="0.00"
                        outlined
                        dense
                        hide-details="auto"
                        prepend-inner-icon="lni lni-dollar"
                        @keypress="$pgsHelper.onlyNumber($event, precioCompra)"
                        step="any"
                        class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12" class="py-1">
                      <v-autocomplete
                        v-model="monedaCompra"
                        :items="monedas"
                        item-value="id"
                        item-text="Nombre"
                        label="Moneda Compra"
                        outlined
                        dense
                        hide-details="auto"
                        class="rounded-lg"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Venta: Precio y Moneda -->
                    <v-col md="6" cols="12" class="py-1 mt-2">
                      <v-text-field
                        v-model="newPrice"
                        type="number"
                        label="Precio de Venta"
                        placeholder="0.00"
                        outlined
                        dense
                        hide-details="auto"
                        prepend-inner-icon="lni lni-dollar"
                        @keypress="$pgsHelper.onlyNumber($event, newPrice)"
                        step="any"
                        :error-messages="errors.precio || []"
                        :error="!!errors.precio"
                        class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12" class="py-1 mt-2">
                      <v-autocomplete
                        v-model="monedaVenta"
                        :items="monedas"
                        item-value="id"
                        item-text="Nombre"
                        label="Moneda Venta"
                        outlined
                        dense
                        hide-details="auto"
                        class="rounded-lg"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Cantidad Recibida -->
                    <v-col cols="12" class="py-1 mt-2">
                      <v-text-field
                        v-model="cantidad"
                        type="number"
                        label="Cantidad de Producto Recibida"
                        placeholder="Cantidad"
                        outlined
                        dense
                        hide-details="auto"
                        prepend-inner-icon="lni lni-calculator"
                        @keypress="$pgsHelper.onlyNumber($event, cantidad)"
                        :error-messages="errors.cantidad || []"
                        :error="!!errors.cantidad"
                        class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Botones de Acción -->
                  <div class="d-flex justify-end mt-6 pt-2" style="gap: 12px;">
                    <v-btn
                      color="grey darken-1"
                      text
                      class="rounded-pill font-weight-bold px-4"
                      @click="$emit('toggle', false)"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      class="rounded-pill font-weight-bold px-6 elevation-1"
                      @click="checkForm()"
                    >
                      <i class="lni lni-save mr-1"></i> Guardar
                    </v-btn>
                  </div>
                </v-card>
              </v-col>

            </v-row>
          </v-form>
          
          <modal
            v-model="showModalFactura"
            :showFooter="false"
            title="Agregar nueva factura"
          >
            <FacturaForm
              :key="keyformFactura"
              @successData="saveFactura"
              @toggle="showModalFactura = false"
            ></FacturaForm>
          </modal>
        </div>
      </v-card-text>
    </v-card>
  </transition>
</template>

<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.product-exist-card {
  border-radius: 16px !important;
  overflow: hidden;
}
.info-banner {
  background: linear-gradient(135deg, #f8f9fa 0%, #eef1f6 100%);
  border-left: 4px solid #404c95;
  border-radius: 8px;
  box-shadow: inset 0 0 8px rgba(0,0,0,0.02);
}
.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #34495e;
  letter-spacing: 0.2px;
}
.bill-chip {
  font-weight: 500;
  font-size: 0.75rem !important;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.bill-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}
.model-select-wrapper {
  position: relative;
}
.model-select-wrapper label {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 600;
  margin-left: 2px;
  display: inline-block;
  margin-bottom: 6px;
}
.model-select-wrapper ::v-deep .ui.selection.dropdown {
  border-radius: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.22) !important;
  padding: 10px 12px !important;
  min-height: 40px !important;
  transition: all 0.2s ease;
  background-color: #fff !important;
  box-shadow: none !important;
}
.model-select-wrapper ::v-deep .ui.selection.dropdown:focus-within {
  border-color: #404c95 !important;
  box-shadow: 0 0 0 1px #404c95 !important;
}
.model-select-wrapper.has-error ::v-deep .ui.selection.dropdown {
  border-color: #ff5252 !important;
}
.helper-banner {
  background-color: #fafbfc;
  border: 1px dashed rgba(64, 76, 149, 0.2);
  border-radius: 8px;
}
.v-text-field--outlined.v-input--dense ::v-deep fieldset {
  border-radius: 8px !important;
}
.v-autocomplete--outlined.v-input--dense ::v-deep fieldset {
  border-radius: 8px !important;
}
</style>

<script>
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import modal from "../../MainComponents/modal.vue";
import FacturaForm from "../../Inventarios/RecepcionMercancias/FacturaForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "ProductExistForm",
  components: {
    modal,
    FacturaForm,
    ModelSelect,
  },
  props: ["edit", "dataEdit", "loadData", "facturasDocument", "Origen"],
  data() {
    return {
      Unidad: "",
      provedorSearch: "",
      searchText: "",
      item2: "",
      keyformFactura: 1,
      producto: "",
      actualExist: 0,
      actualPrice: 0,
      nombre: "",
      codigo: "",
      showModalFactura: false,
      newFactura: "",
      proveedor: " ",
      actualMoneda: "MXN",
      cantidad: "",
      factura: "",
      newPrice: "",
      precioCompra: "",
      monedaCompra: "MXN",
      monedaVenta: "MXN",
      errors: {},
      loader: true,
      facturaNombre: "",
      proveedorNombre: "",
      products: [],
      facturasArray: [],
      proveedorArray: [],
    };
  },
  methods: {
    selectExistFactura(data) {
      this.facturasArray = [{ id: data.Id, Nombre: data.Nombre }];
      this.proveedorArray = [{ id: data.ProvId, Nombre: data.ProvNombre }];
      this.factura = data.Id;
      this.provedorSearch = data.ProvId;
    },
    async onSelectProv(item) {
      if (item != "") {
        this.facturasArray = [];
        let searchText = item.toUpperCase();
        const database = this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("PDV/Productos/Facturas", [
          database.orderByChild("PVDR_ID~~PVDR_NAME~~NAME"),
          database.startAt(searchText),
          database.endAt(searchText + "\uf8ff"),
        ]);

        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }
    },
    async searchProv(searchText) {
      if (searchText != "") {
        this.proveedorArray = [];
        let text = searchText.toUpperCase();
        const database = this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("AMC/Provedores", []);

        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
        }
      }
    },
    async searchProveedor(searchText) {
      if (searchText != "") {
        this.facturasArray = [];
        searchText = searchText.toUpperCase();
        const database = this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("PDV/Productos/Facturas", [
          database.orderByChild("NAME~~PVDR_NAME~~PVDR_ID"),
          database.startAt(searchText),
          database.endAt(searchText + "\uf8ff"),
        ]);
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }
    },
    saveFactura(datos) {
      let sendData = {
        Nombre: datos.factura,
        ProvId: datos.proveedor,
        ProvNombre: datos.proveedorNombre,
        Creacion: new moment().format("YYYY-MM-DD"),
      };
      this.$pgsHelper.log(sendData);
      this.$swal({
        allowOutsideClick: false,
        title: "¿Deseas crear esta nueva factura?",
        text: "Se registrar la factura con los datos indicados ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-createFactura", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La factura se guardo corretamente",
              icon: "success",
            });

            this.showModalFactura = false;
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.Unidad = producto?.Extra?.AYB?.UM || "PZA";
      this.actualExist = producto?.Existencia || 0;
      this.nombre = producto?.Nombre || "";
      this.actualPrice = producto?.Precio || 0;
      this.codigo = producto?.Codigo || "";
      this.actualMoneda = producto?.Moneda || "MXN";
    },
    getProductoById(code) {
      let prod = this.$store.getters.getProductos;
      let itemIndex = this.$_.findIndex(prod, { id: code });
      if (itemIndex >= 0) {
        return prod[itemIndex];
      }

      return false;
    },
    checkForm: function () {
      let valid = true;
      this.errors = {};

      if (!this.producto) {
        this.$set(this.errors, "producto", "El producto es obligatorio");
        valid = false;
      } else {
        this.$delete(this.errors, "producto");
      }

      if (!this.cantidad) {
        this.$set(this.errors, "cantidad", "La cantidad a ingresar es obligatoria");
        valid = false;
      } else {
        this.$delete(this.errors, "cantidad");
      }
      
      if (!this.factura) {
        this.$set(this.errors, "factura", "La factura es obligatoria");
        valid = false;
      } else {
        this.$delete(this.errors, "factura");
      }

      if (this.newPrice === "" || this.newPrice === undefined) {
        this.$set(this.errors, "precio", "El precio de venta es obligatorio");
        valid = false;
      } else {
        this.$delete(this.errors, "precio");
      }

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        this.facturasArray.forEach((element) => {
          if (element.id == this.factura) {
            this.facturaNombre = element.Nombre;
          }
        });

        this.proveedorArray.forEach((element) => {
          if (element.id == this.provedorSearch) {
            this.proveedorNombre = element.Nombre;
          }
        });
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    ...mapGetters(["getPDVMonedasLista"]),
    monedas() {
      let monedas = [];
      this.getPDVMonedasLista.forEach((moneda) => {
        monedas.push(moneda);
      });
      return monedas;
    },
    comp_suggest_price() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let precio_existencia = null;

      origenes.forEach((origen, index) => {
        if (origen.Origen == this.Origen) {
          this.$pgsHelper.log(origen.Productos);
          this.$pgsHelper.log(this.producto);
          let OrProd = Object.entries(origen.Productos);
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == this.producto) {
              this.$pgsHelper.log("Existencia detectada");
              precio_existencia = oProducto[1];
            }
          });
        }
      });

      let returnData = { PCP: 0, PV: 0, PVP: 0, Stock: 0 };

      if (precio_existencia) {
        returnData = precio_existencia;
      }

      return returnData;
    },
    comp_prod() {
      let producto = this.$store.getters.getProductos;
      let prod = [{ id: "", text: "Seleccione un producto" }];
      producto.forEach((ele) => {
        if (
          ele.Tipo != "Servicio" &&
          ele.Tipo != "Producto-NInv" &&
          ele.Tipo != "AYB-Producto" &&
          ele.Tipo != "AYB-ICompuesto" &&
          !ele.Dlat
        ) {
          prod.push({ id: ele.id, text: ele.Nombre });
        }
      });
      return prod;
    },
    comp_fact() {
      let fact = [];
      this.facturasArray.forEach((element) => {
        fact.push({
          value: element.id,
          text: element.Nombre + " - " + element.Proveedor,
        });
      });

      return fact;
    },
    comp_proveedor() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
  },
  watch: {
    producto: function (val) {
      this.getDetail(val);
    },
    provedorSearch: function (val) {
      this.onSelectProv(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
    if (this.loadData) {
      this.producto = this.loadData.ProductoId;
    }
  },
};
</script>
